import { cx } from '@twind/core';
import { Body } from 'app/components/Typography';
import useNextOnlineTime from 'app/modules/live-chat/hooks/useNextOnlineTime';

type Props = {
  isOnline: boolean;
  nextOnlineTime: string;
};

const NetworkStatusIndicator = ({ isOnline, nextOnlineTime }: Props) => {
  const nextTime = useNextOnlineTime(nextOnlineTime);

  return (
    <Body
      id="ostro-live-chat-status"
      className={cx(
        'flex h-[20px] items-center rounded-lg px-2 text-xs leading-3 font-medium whitespace-nowrap',
        isOnline ? 'bg-[#CFEDCA]' : 'bg-option'
      )}
    >
      {isOnline ? 'Online' : nextTime}
    </Body>
  );
};

export default NetworkStatusIndicator;
